import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useQueryLoading } from '@vue/apollo-composable';
import { toNumber } from 'lodash';
import { FundStrategy, ReportType, useAddReportAnswerMutation, useGetAccountQuery, useGetFundIsInSyncQuery, useGetFundQuery, useGetUserQuery, useListReferencePeriodsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: '_fund',
  setup: function setup(__props) {
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        isImpersonated: false
      };
    });
    var route = useRoute();
    var router = useRouter();
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var locale = computed(function () {
      return $i18n.locale;
    });
    var fundId = computed(function () {
      var _route$params;
      return toNumber(route === null || route === void 0 ? void 0 : (_route$params = route.params) === null || _route$params === void 0 ? void 0 : _route$params.fund);
    });
    var initialDataFetched = ref(false);
    var _useGetFundQuery = useGetFundQuery({
        id: fundId.value
      }),
      result = _useGetFundQuery.result,
      refetch = _useGetFundQuery.refetch;
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value$, _accountResult$value;
      return (_accountResult$value$ = (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount) !== null && _accountResult$value$ !== void 0 ? _accountResult$value$ : null;
    });
    var fund = computed(function () {
      var _result$value$getFund, _result$value;
      return (_result$value$getFund = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getFund) !== null && _result$value$getFund !== void 0 ? _result$value$getFund : null;
    });
    var _useGetFundIsInSyncQu = useGetFundIsInSyncQuery({
        id: fundId.value
      }),
      isInSyncResult = _useGetFundIsInSyncQu.result;
    var isInSync = computed(function () {
      var _isInSyncResult$value, _isInSyncResult$value2;
      return ((_isInSyncResult$value = isInSyncResult.value) === null || _isInSyncResult$value === void 0 ? void 0 : (_isInSyncResult$value2 = _isInSyncResult$value.getFund) === null || _isInSyncResult$value2 === void 0 ? void 0 : _isInSyncResult$value2.isInSync) || false;
    });
    var _useListReferencePeri = useListReferencePeriodsQuery({
        filters: {
          isAnnual: true,
          userDefined: false
        },
        sort: 'asc'
      }),
      refPeriodResult = _useListReferencePeri.result;
    var referencePeriodObjects = computed(function () {
      var _refPeriodResult$valu, _refPeriodResult$valu2;
      return (_refPeriodResult$valu = refPeriodResult === null || refPeriodResult === void 0 ? void 0 : (_refPeriodResult$valu2 = refPeriodResult.value) === null || _refPeriodResult$valu2 === void 0 ? void 0 : _refPeriodResult$valu2.listReferencePeriods) !== null && _refPeriodResult$valu !== void 0 ? _refPeriodResult$valu : [];
    });
    var prevYearsRefPeriod = computed(function () {
      if (!referencePeriods.value || referencePeriods.value.length === 0) return null;
      return _toConsumableArray(referencePeriods.value).sort(function (a, b) {
        return Number(b.label) - Number(a.label);
      })[0];
    });
    var referencePeriods = computed(function () {
      var _fund$value;
      if (!fund.value) return [];
      var answers = [];
      if (((_fund$value = fund.value) === null || _fund$value === void 0 ? void 0 : _fund$value.fundStrategy) === FundStrategy.OnlyPais) {
        var _fund$value2;
        answers = Object.values(((_fund$value2 = fund.value) === null || _fund$value2 === void 0 ? void 0 : _fund$value2.paiAnswers) || []);
      } else {
        var _fund$value3;
        answers = Object.values(((_fund$value3 = fund.value) === null || _fund$value3 === void 0 ? void 0 : _fund$value3.periodicAnswers) || []);
      }
      return answers.map(function (a) {
        return a.sfdrReportingPeriod;
      });
    });
    watch([function () {
      var _route$query;
      return (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.referencePeriodId;
    }, function () {
      return fund.value;
    }], function (_ref, _ref2) {
      var _ref3 = _slicedToArray(_ref, 2),
        newReferencePeriodId = _ref3[0],
        newFund = _ref3[1];
      var _ref4 = _slicedToArray(_ref2, 2),
        oldReferencePeriodId = _ref4[0],
        oldFund = _ref4[1];
      // Check if the fund object has just become available
      if (newFund && !oldFund && !initialDataFetched.value) {
        initialDataFetched.value = true; // Mark initial data fetch complete
        if (newReferencePeriodId) {
          triggerAddReportAnswer(Number(newReferencePeriodId));
        }
      }

      // Check if the reference period has changed and the fund data is already fetched
      if (newReferencePeriodId && newReferencePeriodId !== oldReferencePeriodId && initialDataFetched.value) {
        triggerAddReportAnswer(Number(newReferencePeriodId));
      }
    }, {
      immediate: true
    } // This option ensures the watcher is triggered immediately with the current values
    );
    var referencePeriodI18n = {
      en: 'Reference period',
      de: 'Berichtszeitraum'
    };
    var formattedReferencePeriods = computed(function () {
      return referencePeriods.value.sort(function (a, b) {
        return Number(a.label) - Number(b.label);
      }).map(function (period) {
        var _period$label, _period$id;
        return {
          text: "".concat(referencePeriodI18n[locale.value], " ").concat((_period$label = period === null || period === void 0 ? void 0 : period.label) !== null && _period$label !== void 0 ? _period$label : 'N/A'),
          value: Number((_period$id = period === null || period === void 0 ? void 0 : period.id) !== null && _period$id !== void 0 ? _period$id : 0)
        };
      });
    });
    var _useAddReportAnswerMu = useAddReportAnswerMutation(),
      addReportAnswer = _useAddReportAnswerMu.mutate;
    var triggerAddReportAnswer = function triggerAddReportAnswer(referencePeriodId) {
      var _fund$value4, _fund$value5, _fund$value5$paiAnswe, _fund$value6, _fund$value6$entityWe, _fund$value7, _fund$value7$precontr, _fund$value8, _fund$value8$periodic, _fund$value9, _fund$value9$fundWebs;
      var trigger_refetch = false;
      // Ensure necessary report answers exist according to fund specifications.
      if (!referencePeriodId) {
        console.error('referencePeriodId is unknown!!!');
        return;
      }
      if (loading.value || !fund.value) {
        return;
      }
      if ((_fund$value4 = fund.value) !== null && _fund$value4 !== void 0 && _fund$value4.isReportingPais && !((_fund$value5 = fund.value) !== null && _fund$value5 !== void 0 && (_fund$value5$paiAnswe = _fund$value5.paiAnswers) !== null && _fund$value5$paiAnswe !== void 0 && _fund$value5$paiAnswe.find(function (answer) {
        return answer.referencePeriodId === referencePeriodId;
      }))) {
        var input = {
          fundId: fundId.value,
          referencePeriodId: referencePeriodId,
          reportType: ReportType.SfdrPai
        };
        addReportAnswer({
          input: input
        });
        trigger_refetch = true;
      }
      if (!((_fund$value6 = fund.value) !== null && _fund$value6 !== void 0 && (_fund$value6$entityWe = _fund$value6.entityWebsiteDisclosureAnswers) !== null && _fund$value6$entityWe !== void 0 && _fund$value6$entityWe.find(function (answer) {
        return answer.referencePeriodId === referencePeriodId;
      }))) {
        var _input = {
          fundId: fundId.value,
          referencePeriodId: referencePeriodId,
          reportType: ReportType.SfdrEntityWebsiteDisclosure
        };
        addReportAnswer({
          input: _input
        });
        trigger_refetch = true;
      }
      if (!((_fund$value7 = fund.value) !== null && _fund$value7 !== void 0 && (_fund$value7$precontr = _fund$value7.precontractualAnswers) !== null && _fund$value7$precontr !== void 0 && _fund$value7$precontr.find(function (answer) {
        return answer.referencePeriodId === referencePeriodId;
      }))) {
        var _input2 = {
          fundId: fundId.value,
          referencePeriodId: referencePeriodId,
          reportType: ReportType.SfdrPrecontractual
        };
        addReportAnswer({
          input: _input2
        });
        trigger_refetch = true;
      }
      if (!((_fund$value8 = fund.value) !== null && _fund$value8 !== void 0 && (_fund$value8$periodic = _fund$value8.periodicAnswers) !== null && _fund$value8$periodic !== void 0 && _fund$value8$periodic.find(function (answer) {
        return answer.referencePeriodId === referencePeriodId;
      }))) {
        var _input3 = {
          fundId: fundId.value,
          referencePeriodId: referencePeriodId,
          reportType: ReportType.SfdrPeriodic
        };
        addReportAnswer({
          input: _input3
        });
        trigger_refetch = true;
      }

      // If the website disclosure answer for the reference period does not exist, create a new report answer.
      if (!((_fund$value9 = fund.value) !== null && _fund$value9 !== void 0 && (_fund$value9$fundWebs = _fund$value9.fundWebsiteDisclosureAnswers) !== null && _fund$value9$fundWebs !== void 0 && _fund$value9$fundWebs.find(function (answer) {
        return answer.referencePeriodId === referencePeriodId;
      }))) {
        var _input4 = {
          fundId: fundId.value,
          referencePeriodId: referencePeriodId,
          reportType: ReportType.SfdrFundWebsiteDisclosure
        };
        addReportAnswer({
          input: _input4
        });
        trigger_refetch = true;
      }
      if (trigger_refetch) {
        refetch();
      }
    };
    watch(prevYearsRefPeriod, /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(prevYear) {
        var _route$query2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(prevYear && !((_route$query2 = route.query) !== null && _route$query2 !== void 0 && _route$query2.referencePeriodId))) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return router.replace({
                query: _objectSpread(_objectSpread({}, route.query), {}, {
                  referencePeriodId: prevYear.id
                })
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }(), {
      immediate: true
    } // runs on mount
    );
    var considersPais = computed(function () {
      var _fund$value10, _fund$value11;
      return ((_fund$value10 = fund.value) === null || _fund$value10 === void 0 ? void 0 : _fund$value10.isReportingPais) || (fund === null || fund === void 0 ? void 0 : (_fund$value11 = fund.value) === null || _fund$value11 === void 0 ? void 0 : _fund$value11.isConsideringPais) !== 'NO';
    });
    var paiOnly = computed(function () {
      var _fund$value12;
      return ((_fund$value12 = fund.value) === null || _fund$value12 === void 0 ? void 0 : _fund$value12.fundStrategy) === 'ARTICLE_6' && considersPais.value;
    });
    var tabLabelMappings = {
      entityWebsiteDisclosure: {
        en: 'ENTITY WEBSITE DISCLOSURE',
        de: 'UNTERNEHMENSWEBSITE-ANGABEN'
      },
      kpi: {
        en: 'KPI',
        de: 'KPI'
      },
      pai: {
        en: 'PAI',
        de: 'PAI'
      },
      precontractual: {
        en: 'PRECONTRACTUAL',
        de: 'VORVERTRAGLICHE'
      },
      periodic: {
        en: 'PERIODIC',
        de: 'REGELMÄSSIGE'
      },
      fundWebsiteDisclosure: {
        en: 'FUND WEBSITE DISCLOSURE',
        de: 'FONDS-WEBSITE-ANGABEN'
      },
      precontractualArticle6: {
        en: 'PRECONTRACTUAL',
        de: 'VORVERTRAGLICHE'
      }
    };
    var headers = computed(function () {
      var _fund$value13, _fund$value14, _fund$value15, _fund$value16;
      var baseHeaders = [{
        label: tabLabelMappings.entityWebsiteDisclosure[locale.value],
        link: 'entityWebsiteDisclosure',
        sort: 4
      }, {
        label: tabLabelMappings.kpi[locale.value],
        link: 'kpi',
        sort: 100
      }];
      if (!fund.value) return baseHeaders;
      var paiHeaders = {
        label: tabLabelMappings.pai[locale.value],
        link: 'pai',
        sort: 2
      };
      var precontractualArticle6Headers = {
        label: tabLabelMappings.precontractualArticle6[locale.value],
        link: 'precontractualArticle6',
        sort: 0
      };
      if (((_fund$value13 = fund.value) === null || _fund$value13 === void 0 ? void 0 : _fund$value13.fundStrategy) === FundStrategy.Article_6 && considersPais.value) {
        return [].concat(baseHeaders, [paiHeaders, precontractualArticle6Headers]).sort(function (a, b) {
          return a.sort - b.sort;
        });
      }
      baseHeaders.push({
        label: tabLabelMappings.precontractual[locale.value],
        link: 'precontractual',
        sort: 0
      });
      baseHeaders.push({
        label: tabLabelMappings.periodic[locale.value],
        link: 'periodic',
        sort: 1
      });
      if (considersPais.value) {
        baseHeaders.push(paiHeaders);
      }
      if (((_fund$value14 = fund.value) === null || _fund$value14 === void 0 ? void 0 : _fund$value14.fundStrategy) === FundStrategy.Article_8Plus || ((_fund$value15 = fund.value) === null || _fund$value15 === void 0 ? void 0 : _fund$value15.fundStrategy) === FundStrategy.Article_8 || ((_fund$value16 = fund.value) === null || _fund$value16 === void 0 ? void 0 : _fund$value16.fundStrategy) === FundStrategy.Article_9) {
        baseHeaders.push({
          label: tabLabelMappings.fundWebsiteDisclosure[locale.value],
          link: 'fundWebsiteDisclosure',
          sort: 3
        });
      }
      return baseHeaders.sort(function (a, b) {
        return a.sort - b.sort;
      });
    });
    var numberOfCompanies = computed(function () {
      var _fund$value17, _fund$value18;
      return fund !== null && fund !== void 0 && (_fund$value17 = fund.value) !== null && _fund$value17 !== void 0 && _fund$value17.ventureIds ? fund === null || fund === void 0 ? void 0 : (_fund$value18 = fund.value) === null || _fund$value18 === void 0 ? void 0 : _fund$value18.ventureIds.length : 0;
    });
    var loading = useQueryLoading();
    var fundSetupUrl = computed(function () {
      return "/portfolio/funds/edit/".concat(fundId.value, "?step=outro");
    });
    return {
      __sfc: true,
      userResult: userResult,
      user: user,
      route: route,
      router: router,
      $i18n: $i18n,
      locale: locale,
      fundId: fundId,
      initialDataFetched: initialDataFetched,
      result: result,
      refetch: refetch,
      accountResult: accountResult,
      account: account,
      fund: fund,
      isInSyncResult: isInSyncResult,
      isInSync: isInSync,
      refPeriodResult: refPeriodResult,
      referencePeriodObjects: referencePeriodObjects,
      prevYearsRefPeriod: prevYearsRefPeriod,
      referencePeriods: referencePeriods,
      referencePeriodI18n: referencePeriodI18n,
      formattedReferencePeriods: formattedReferencePeriods,
      addReportAnswer: addReportAnswer,
      triggerAddReportAnswer: triggerAddReportAnswer,
      considersPais: considersPais,
      paiOnly: paiOnly,
      tabLabelMappings: tabLabelMappings,
      headers: headers,
      numberOfCompanies: numberOfCompanies,
      loading: loading,
      fundSetupUrl: fundSetupUrl,
      toNumber: toNumber,
      ReportType: ReportType
    };
  }
});